export function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

export const onResizeStop = (callback, delay = 66) => {
  let scrollingTimeout = false;

  const handleScroll = (event) => {
    clearTimeout(scrollingTimeout);
    scrollingTimeout = setTimeout(() => {
      callback(event);
    }, delay);
  };
  window.addEventListener('resize', handleScroll);

  return () => {
    window.removeEventListener('resize', handleScroll);
  };
};
